module.exports = "/_next/static/images/JettyBackgroundMorowali-a9d05b82fa22e88e53b33343f2d0bbd1.png";